import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
//import BootstrapVue from 'bootstrap-vue'
//import Vuetify from 'vuetify'
import PrimeVue from "primevue/config";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dropdown from "primevue/dropdown";
import InputText from "primevue/inputtext";
import FileUpload from "primevue/fileupload";
import Textarea from "primevue/textarea";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import DataView from "primevue/dataview";
import ProgressBar from "primevue/progressbar";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import Password from "primevue/password";
import { VueReCaptcha } from "vue-recaptcha-v3";
import Vue3PersianDatetimePicker from "vue3-persian-datetime-picker";

import $ from "jquery";
import ls from "localstorage-slim";
import encUTF8 from "crypto-js/enc-utf8";
import AES from "crypto-js/aes";

ls.config.encrypt = true;
ls.config.secret = "scrt";

ls.config.encrypter = (data, secret) =>
  AES.encrypt(JSON.stringify(data), secret).toString();
ls.config.decrypter = (data, secret) => {
  try {
    return JSON.parse(AES.decrypt(data, secret).toString(encUTF8));
  } catch (e) {
    // incorrect/missing secret, return the encrypted data instead
    return data;
  }
};

// intercept requests for errors
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (!error.response) {
      ls.clear();
      router.push("/login");
    } else if (error.response.status === 401 && error.response.status) {
      ls.clear();
      router.push("/login");
    } else if (error.response.status === 403 && error.response.status) {
      ls.clear();
      router.push("/login");
    }
    return Promise.reject(error);
  }
);

axios.defaults.baseURL = "https://service.howbir.com";
try {
  axios.defaults.headers.common["Authorization"] = "Bearer " + ls.get("token");
} catch (error) {
  ls.clear();
  router.push("/login");
}

try {
  if (typeof window.console != "undefined") {
    window.console = {};
    window.console.log = function () {};
    window.console.debug = function () {};
    window.console.info = function () {};
    window.console.warn = function () {};
    window.console.error = function () {};
  }

  if (typeof alert !== "undefined") {
    alert = function () {};
  }
} catch (ex) {}

createApp(App)
  .use(store)
  .mixin({
    methods: {
      parseTimes(d) {
        var res = "";
        try {
          res = new Intl.DateTimeFormat("fa-IR", { timeStyle: "short" }).format(
            new Date(d)
          );
        } catch (e) {
          res = "نامعلوم";
        }
        return res;
      },
      scrollToTop() {
        document.getElementById("app").scrollIntoView({ behavior: "smooth" });
      },
      closeModal(modalId) {
        $(modalId).modal("hide");
      },
      openModal(modalId) {
        var modal = new bootstrap.Modal(document.getElementById(modalId));
        modal.show();
      },
      toEngDigit(e) {
        try {
          return e.replace(/[٠-٩۰-۹]/g, (e) => 15 & e.charCodeAt(0));
        } catch (er) {
          return e;
        }
      },
      formatPrice(value) {
        value = this.toEngDigit(value);
        let val = (value / 1).toFixed(0).replace(",");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      formatTime(value) {
        let val = value.split("-");
        if (val[0] === undefined || val[1] === undefined) {
          return "";
        }
        return `${val[0]}` + "ساعت و " + `${val[1]}` + "دقیقه";
      },
      parseDates(d) {
        var res = "";
        try {
          res = new Intl.DateTimeFormat("fa-IR", { dateStyle: "long" }).format(
            new Date(d)
          );
        } catch (e) {
          res = "نامعلوم";
        }
        return res;
      },
      parseDatest(d) {
        var res = "";
        try {
          res = new Intl.DateTimeFormat("fa-IR", {
            dateStyle: "long",
            timeStyle: "short",
          }).format(new Date(d));
        } catch (e) {
          res = "نامعلوم";
        }
        return res;
      },
    },
  })
  .use(Vue3PersianDatetimePicker, {
    name: "custom-date-picker",
    props: {
      inputClass: "datepicker-form-control",
      placeholder: "انتخاب زمان",
      altFormat: "YYYY/M/D",
      type: "time",
    },
  })
  .use(VueReCaptcha, {
    siteKey: "6LeRCscZAAAAAOY3cdLUhz4YTzxo83qCAc4Uf-lT",
    loaderOptions: { autoHideBadge: false, hl: "fa" },
  })
  .use(router)
  .use(PrimeVue)
  .use(ToastService)
  .component("Toast", Toast)
  .component("Button", Button)
  .component("Password", Password)
  .component("ProgressBar", ProgressBar)
  .component("Dialog", Dialog)
  .component("DataView", DataView)
  .component("TextArea", Textarea)
  .component("FileUpload", FileUpload)
  .component("DataTable", DataTable)
  .component("Column", Column)
  .component("Dropdown", Dropdown)
  .component("InputText", InputText)
  .mount("#app");
